<template>
    <div v-show="list.length!=0" class="aside-3">
        <dl>
            <div class="title"><i></i>{{title}}</div>
        </dl>
       
        <dd v-if="!type" v-for="(item,index) in list">
            <a :href="item.open_type==0?`/news/${item.id}`:item.third_url" target="_blank" alt="...">
                <img   v-lazy="{
                    loading: lazyLoading,
                    error: lazyLoading,
                    src: item.img_url[0]
                  }" data-src="/public/w/img/wap/loading.png" alt="..."> <p>{{item.title}}</p></a>
        </dd>
        <dd v-if="type" v-for="(item,index) in list">
                <a  :href="item.open_type==0?`/news/${item.id}`:item.third_url"  target="_blank" alt="...">
                    <img   v-lazy="{
                        loading: lazyLoading,
                        error: lazyLoading,
                        src: item.img_url[0]
                      }" data-src="/public/w/img/wap/loading.png" alt="..."> <p>{{item.title}}</p></a>
         </dd>
    </div>
</template>
<script>
    import {
        format
    } from 'date-fns';
    import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
    export default {
        props: ['title', 'list', 'type', 'clientId'],
        components: {},
        computed: {
            lazyLoading() {
                if (this.clientId) {
                    return `/public/w/img/${this.clientId}/loading_news.png`;
                } else {
                    return '/public/w/default/loading_news.png';
                }
            }
        },
        data() {
            return {
                format
            }
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-aside/img-aside.vue